







import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class FormattedAddress extends Vue {
  @Prop({ default: false }) readonly isApproximate?: boolean;
  @Prop() readonly unitNumber?: string;
  @Prop() readonly streetNumber?: string;
  @Prop() readonly street?: string;
  @Prop() readonly suburb?: string;
}
